const pubsub = require('events/pubsub');
const model = require('model/model');
const analyticsUtilities = require('utilities/analyticsUtilities');

const fireEvent = analyticsUtilities.fireEvent;
const NATIVE_PRINT = analyticsUtilities.events.NATIVE_PRINT;

const adblock = !window.adsByGoogleLoaded || !window.showAdsLoaded;

function printStart() {
	let activeProduct = model.get('activeProduct');
	let articleTab = model.get('articleTab');
	let activeProductId = activeProduct ? activeProduct.id || activeProduct.uuid : null;
	let questionsetsSection = model.get('questionsetsSection');
	let stepreadsSection = model.get('stepreadsSection');
	let contentSection = model.get('contentSection');
	let ebookPage = model.get('ebookPage');

	let data = {
		articleTab,
		pid: activeProductId,
		questionsetsSection,
		stepreadsSection,
		contentSection,
		ebookPage,
		adblock
	};

	pubsub.publish('print-start');
	fireEvent(NATIVE_PRINT, data);
}

function printEnd() {
	pubsub.publish('print-end');
}

if (window.onbeforeprint === null) {
	window.onbeforeprint = function () {
		printStart();
	};

	window.onafterprint = function () {
		printEnd();
	};
} else {
	window.matchMedia('print').addListener(function (mql) {
		if (mql.matches) {
			printStart();
		} else {
			printEnd();
		}
	});
}

module.exports = true;
